import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LanguageProvider } from './components/language-provider'
import { ErrorBoundary } from './components/error-boundary'
import PageLayout from './components/page-layout'
import Header from './components/header'
import Footer from './components/footer'
import HomePage from './pages/home'
import AboutPage from './pages/about'
import ServicesPage from './pages/services'
import ContactPage from './pages/contact'
import ComplimentsPage from './pages/compliments'
import NewsPage from './pages/news'
import LumosNewsPage from './pages/news/lumos'
import Pulse7NewsPage from './pages/news/pulse-7'
import XmasSonetSortNewsPage from './pages/news/xmasinsonetsort'
import EvelinaXmasNewsPage from './pages/news/xmasinevelina'
import HaberdashersNewsPage from './pages/news/haberdashers'
import Pulse6NewsPage from './pages/news/pulse-6'
import Pulse5NewsPage from './pages/news/pulse-5'
import KingussieNewsPage from './pages/news/kingussieschool'
import BearsInDubaiNewsPage from './pages/news/bears-dubai'
import SwanscombeNewsPage from './pages/news/swanscombe'
import ChristmasNewsPage from './pages/news/christmas'
import Pulse4NewsPage from './pages/news/pulse-4'
import Pulse3NewsPage from './pages/news/pulse-3'
import ForsNewsPage from './pages/news/fors'
import FritwellFundraisingNewsPage from './pages/news/fritwell-fundraising'
import WhitchurchStemNewsPage from './pages/news/whitchurch-stem'
import AmericanSchoolFairNewsPage from './pages/news/american-school-fair'
import EcmoAmbulanceLaunchNewsPage from './pages/news/ecmo-ambulance-launch'
import Pulse2NewsPage from './pages/news/pulse-2'
import HaloBodyCamsNewsPage from './pages/news/halo-body-cams'
import CareersPage from './pages/careers'
import TeamPage from './pages/team'
import CubsPage from './pages/cubs'
import FleetPage from './pages/fleet'
import OurValuesPage from './pages/our-values'
import BearsInNumbersPage from './pages/bears-in-numbers'
import NeptsPage from './pages/services/nepts'
import ParamedicPage from './pages/services/paramedic'
import BariatricPage from './pages/services/bariatric'
import CriticalRetrievalPage from './pages/services/critical-retrieval'
import EcmoPage from './pages/services/ecmo'
import HighDependancePage from './pages/services/high-dependance'
import MentalHealthPage from './pages/services/mental-health'
import NeonatalPage from './pages/services/neonatal'
import ScrollToTop from './components/common/ScrollToTop'
import TermsAndConditionsPage from './pages/terms-and-conditions'
import CarbonReductionPlanPage from './pages/carbon-reduction-plan'
import PatientSurveyPage from './pages/patient-survey'
import AmbulanceCareAssistantSecure from './pages/vacancies/ambulance-care-assistant-secure'
import FirstLineManager from './pages/vacancies/first-line-manager'
import NeptsBusinessIntelligenceControlTeamManager from './pages/vacancies/nepts-business-intelligence-control-team-manager'
import ParamedicVacancy from './pages/vacancies/paramedic'
import ShiftManager from './pages/vacancies/shift-manager'
import BookingsPage from './pages/bookings'
import AutumnBallPage from './pages/autumn-ball'
import AutumnBall2Page from './pages/autumn-ball2'

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <Router>
          <ScrollToTop />
          <PageLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/nepts" element={<NeptsPage />} />
              <Route path="/services/paramedic" element={<ParamedicPage />} />
              <Route path="/services/bariatric" element={<BariatricPage />} />
              <Route path="/services/critical-retrieval" element={<CriticalRetrievalPage />} />
              <Route path="/services/ecmo" element={<EcmoPage />} />
              <Route path="/services/high-dependance" element={<HighDependancePage />} />
              <Route path="/services/mental-health" element={<MentalHealthPage />} />
              <Route path="/services/neonatal" element={<NeonatalPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/lumos-nursery" element={<LumosNewsPage />} />
              <Route path="/news/pulse-7" element={<Pulse7NewsPage />} />
              <Route path="/news/xmas-in-sonet-sort" element={<XmasSonetSortNewsPage />} />
              <Route path="/news/xmas-in-evelina" element={<EvelinaXmasNewsPage />} />
              <Route path="/news/haberdashers" element={<HaberdashersNewsPage />} />
              <Route path="/news/pulse-6" element={<Pulse6NewsPage />} />
              <Route path="/news/pulse-5" element={<Pulse5NewsPage />} />
              <Route path="/news/kingussieschool" element={<KingussieNewsPage />} />
              <Route path="/news/swanscombe" element={<SwanscombeNewsPage />} />
              <Route path="/news/bears-dubai" element={<BearsInDubaiNewsPage />} />
              <Route path="/news/christmas" element={<ChristmasNewsPage />} />
              <Route path="/news/pulse-4" element={<Pulse4NewsPage />} />
              <Route path="/news/pulse-3" element={<Pulse3NewsPage />} />
              <Route path="/news/fors" element={<ForsNewsPage />} />
              <Route path="/news/fritwell-fundraising" element={<FritwellFundraisingNewsPage />} />
              <Route path="/news/whitchurch-stem" element={<WhitchurchStemNewsPage />} />
              <Route path="/news/american-school-fair" element={<AmericanSchoolFairNewsPage />} />
              <Route path="/news/ecmo-ambulance-launch" element={<EcmoAmbulanceLaunchNewsPage />} />
              <Route path="/news/pulse-2" element={<Pulse2NewsPage />} />
              <Route path="/news/halo-body-cams" element={<HaloBodyCamsNewsPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/cubs" element={<CubsPage />} />
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/our-values" element={<OurValuesPage />} />
              <Route path="/bears-in-numbers" element={<BearsInNumbersPage />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
              <Route path="/carbon-reduction-plan" element={<CarbonReductionPlanPage />} />
              <Route path="/patient-survey" element={<PatientSurveyPage />} />
              <Route path="/vacancies/ambulance-care-assistant-secure" element={<AmbulanceCareAssistantSecure />} />
              <Route path="/vacancies/first-line-manager" element={<FirstLineManager />} />
              <Route path="/vacancies/nepts-business-intelligence-control-team-manager" element={<NeptsBusinessIntelligenceControlTeamManager />} />
              <Route path="/vacancies/paramedic" element={<ParamedicVacancy />} />
              <Route path="/vacancies/shift-manager" element={<ShiftManager />} />
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/autumn-ball" element={<AutumnBallPage />} />
              <Route path="/autumn-ball2" element={<AutumnBall2Page />} />
            </Routes>
          </PageLayout>
        </Router>
      </LanguageProvider>
    </ErrorBoundary>
  )
}

export default App
